export const HIDE = {
  AUTH: 'HIDE_AUTH',
  NO_AUTH: 'HIDE_NO_AUTH',
  NEVER: 'HIDE_NEVER'
}